<template>
<div class="chapter">
<div class="inner_page">
<p class="img"><img alt="CALLING ON JACK PUMPKINHEAD See Chapter 16" class="calibre7" id="id-8772410915513074196" src="Images/img0001.png"/><br/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?3860e914